import { render, staticRenderFns } from "./TopNavbarUserDropdown.vue?vue&type=template&id=1461c4f8&"
import script from "./TopNavbarUserDropdown.vue?vue&type=script&lang=js&"
export * from "./TopNavbarUserDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports